import { render } from "./VendorDropDown.vue?vue&type=template&id=4f6b86b6"
import script from "./VendorDropDown.vue?vue&type=script&lang=js"
export * from "./VendorDropDown.vue?vue&type=script&lang=js"
script.render = render

export default script